import PayPrograms from '../../common/constants/payPrograms';

export default function isMembershipProgram(program) {
  if (!program?.length) {
    return false;
  }
  const membershipPrograms = [PayPrograms.Plus, PayPrograms.Premium];
  return membershipPrograms.some(s => s.toUpperCase() === program.toUpperCase());
}
